import { render, staticRenderFns } from "./NewRirekishoSinglePreview.vue?vue&type=template&id=6e96b4d0"
import script from "./NewRirekishoSinglePreview.vue?vue&type=script&lang=js"
export * from "./NewRirekishoSinglePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports